exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form {\n  margin-top: 20px; }\n\n.card {\n  margin-top: 20px; }\n\n.modal {\n  background: rgba(0, 0, 0, 0.4); }\n\nbutton:disabled {\n  color: #707070; }\n\n.tdTable {\n  max-width: 100px; }\n\ndiv.spinner {\n  height: 10px; }\n\n.alert {\n  font-size: 15px;\n  padding: 20px;\n  background: #2daf42;\n  color: white;\n  min-width: 420px;\n  position: fixed;\n  border-radius: 4px;\n  right: 0;\n  top: 10px;\n  margin-right: 20px;\n  z-index: 1; }\n\n.alert-error {\n  color: white;\n  font-size: 15px;\n  background: #dd4e4e;\n  padding: 20px 40px;\n  min-width: 420px;\n  position: fixed;\n  border-radius: 4px;\n  right: 0;\n  top: 10px;\n  margin-right: 20px;\n  z-index: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/produto-components/precificacao/precificacao.component.scss
// module id = ../../../../../src/app/components/produto-components/precificacao/precificacao.component.scss
// module chunks = main